<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" right="iconadd" @rightClick="onTrueAdd" />
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      :add-button-text="buttonTitle"
      @add="onAdd"
      @edit="onEdit"
      @select="onSelect"
    />
  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { getUrlKey, initPage, MyNotify } from '@/utils/base'
import { Button, AddressList } from 'vant'
import Cookies from 'js-cookie'
export default {
  components: {
    [Button.name]: Button,
    [AddressList.name]: AddressList,
    TopBar
  },
  data() {
    return {
      buttonLoading: false,
      title: '地址管理',
      backurl: '/users/index',
      chosenAddressId: '1',
      list: [],
      type: undefined,
      buttonTitle: '新增地址',
      selectAddress: undefined
    }
  },
  created() {
    initPage()
    var url = getUrlKey('backurl')
    if (url !== null) {
      this.backurl = url
    }
    var type = getUrlKey('type')
    if (type) {
      if (type === 'null') {
        this.type = undefined
        Cookies.remove('addresslistType_')
      } else {
        this.type = type
        Cookies.set('addresslistType_', this.type)
      }
    } else {
      this.type = Cookies.get('addresslistType_')
    }
    if (this.type) {
      this.buttonTitle = '选择地址'
    }
    request({
      url: '/Store/getUserAddressModelList',
      method: 'post'
    }).then(Response => {
      if (Response.success) {
        this.list = Response.data
      }
    })
  },
  methods: {
    onSelect(item, index) {
      this.selectAddress = item
    },
    onTrueAdd() {
      this.$router.replace('/Store/addressEdit?backurl=' + this.backurl)
    },
    onAdd() {
      if (!this.type) {
        this.$router.replace('/Store/addressEdit?backurl=' + this.backurl)
      } else {
        if (!this.selectAddress) {
          MyNotify('info', '请选择收件地址!(右上角可以增加新地址)')
          return
        }
        this.gotoDo()
      }
    },
    onEdit(item, index) {
      this.$router.replace('/Store/addressEdit?addressId=' + item.id + '&backurl=' + this.backurl)
    },
    gotoDo() {
      if (this.type === 'activityCard') {
        if (this.buttonLoading) {
          MyNotify('info', '提交中,请稍后')
          return
        }
        this.buttonLoading = true
        request({
          url: '/Activity/CreateActivityCardOrder',
          method: 'get',
          params: { id: this.selectAddress.id }
        }).then(Response => {
          this.buttonLoading = false
          if (!Response.success) {
            return
          }
          MyNotify('success', '订单创建成功')
          this.$router.replace('/store/orderInfo/' + Response.data + '?backurl=/activity/groupTeams')
        })
      } else if (this.type === 'raffleReg') {
        this.$router.replace('/activity/raffleReg?addressId=' + this.selectAddress.id)
      }
    }
  }
}
</script>

